module.exports = __webpack_public_path__ + "static/s3-icon-centaral-8c45dd9eecdd61687c8b564c5d5f94de.png";